import { lazy } from "react";

export default {
  name: "Proxy",
  path: "/proxy",
  component: lazy(() => import("./index"))
}